module.exports = __webpack_public_path__ + "img/dashboard.e12ef8c3.svg";